import React, { FC } from 'react'
import { isNullOrWhiteSpace } from '../utilities/string'
import { ImageProps } from './Image'
import { PlaceholderImage } from './PlaceholderImage'

export const Portrait: FC<Omit<ImageProps, 'caption'>> = ({
  src,
  altText,
  className,
  pictureClassName,
  imgClassName,
  copyright,
  sources,
  width,
  height,
}) => (
  <figure className={className}>
    <div className="relative rounded overflow-hidden">
      {!isNullOrWhiteSpace(src) ? (
        <picture className={pictureClassName}>
          {!!sources?.length &&
            sources.map((source, i) => (
              <source
                key={i}
                media={`(min-width: ${source.minimumBreakpoint}px)`}
                srcSet={source.srcSet}
                width={source.width}
                height={source.height}
              />
            ))}

          <img
            alt={altText}
            className={imgClassName}
            src={src}
            width={width}
            height={height}
          />
        </picture>
      ) : (
        <PlaceholderImage />
      )}
      <div className="absolute top-0 left-0 w-full h-full bg-shade-lightest-warm blend-multiply" />
    </div>

    {copyright && (
      <footer className="text-center xl:mt-10">
        <small className="font-t-light text-t-100 uppercase text-secondary-darker xl:text-t-200">
          {copyright}
        </small>
      </footer>
    )}
  </figure>
)
